import { CaretDown, CaretUp } from "@phosphor-icons/react";
import { fmtBRL } from "../lib/format";

const fmtQ = (q) => Number(q || 0).toLocaleString("pt-BR", { maximumFractionDigits: 2 });

// Resumo dos itens do pedido na listagem (desktop e cards). Vendedor nunca vê itens internos; admin vê com selo.
export const OrderItemsSummary = ({ order, isVendedor, expanded, onToggle, max = 2, compact = false, testPrefix = "" }) => {
  const items = (order.items || []).filter((it) => !isVendedor || !it.internal);
  if (!items.length) return null;
  const shown = expanded ? items : items.slice(0, max);
  const rest = items.length - shown.length;
  const code = `${testPrefix}${order.code}`;
  return (
    <div data-testid={`order-items-${code}`} className={`mt-1 space-y-0.5 ${compact ? "text-xs" : "text-[11px]"} font-normal`}>
      {shown.map((it, i) => (
        <p key={i} data-testid={`order-item-${code}-${i}`} title={`${fmtQ(it.quant)}x ${it.description} — ${fmtBRL((it.quant || 0) * (it.unit_price || 0))}`}
          className={`flex items-baseline gap-1.5 text-zinc-400 ${compact ? "" : "max-w-[380px]"}`}>
          <span className="shrink-0 text-zinc-500 tabular-nums">{fmtQ(it.quant)}x</span>
          <span className="truncate min-w-0 text-zinc-300">{it.description || "—"}</span>
          {it.internal && !isVendedor && (
            <span data-testid={`order-item-internal-${code}-${i}`} className="shrink-0 text-[9px] font-bold uppercase tracking-wide text-violet-300 border border-violet-800/60 bg-violet-950/60 rounded px-1">interno</span>
          )}
          <span className="shrink-0 text-zinc-500 tabular-nums">— {fmtBRL((it.quant || 0) * (it.unit_price || 0))}</span>
        </p>
      ))}
      {(rest > 0 || expanded) && items.length > max && (
        <button type="button" data-testid={`order-items-toggle-${code}`} onClick={(e) => { e.stopPropagation(); onToggle(); }}
          className="inline-flex items-center gap-1 text-[11px] text-indigo-300 hover:text-indigo-200 transition-colors min-h-[28px] lg:min-h-0">
          {expanded ? <><CaretUp size={11} /> ver menos</> : <><CaretDown size={11} /> +{rest} {rest === 1 ? "item" : "itens"}</>}
        </button>
      )}
    </div>
  );
};
